<template>
  <div
    :class="{
      'grid-container-fi': true,
      'fi-max-w-xl': stretch,
      'fi-container': container,
      'sm:fi-container sm:fi-max-w-xl': containerSm,
      'md:fi-container md:fi-max-w-xl': containerMd,
      'xl:fi-container xl:fi-max-w-xl': containerXl,
    }"
  >
    <div :class="combinedGridClass">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

defineOptions({
  name: 'GridContainerFi',
});

const props = withDefaults(
  defineProps<{
    container?: boolean;
    containerSm?: boolean;
    containerMd?: boolean;
    containerXl?: boolean;
    stretch?: boolean;
    gridBaseClass?: string;
    gridClass?: string;
    limitNonContainerWidth?: boolean;
  }>(),
  {
    container: true,
    stretch: true,
    gridBaseClass: 'fi-grid-cols-12 fi-gap-small md:fi-gap-large',
    gridClass: '',
  },
);

const combinedGridClass = computed<string>(
  () => `fi-grid ${props.gridBaseClass} ${props.gridClass}`,
);
</script>

<style src="./grid-container-fi" />
